// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__kto-m","superscript":"Register_superscript__BVvOj","title":"Register_title__flBV1","button":"Register_button__4goUB","icon":"Register_icon__zgjEN"};